import Routes from '../../shared/routes/index';

export default Routes;